import focusTrapUtility from "utilities/global/focus-trap-utility/1.2.4/js/focus-trap-utility";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.4/js/sparta-events-utility";
import "utilities/global/sparta-global-data-utility/1.0.0/js/sparta-global-data-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.3/js/sparta-global-functions-utility";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/2.0.4/js/sparta-mediaquery-utility";
import spartaSingletonUtility from "utilities/global/sparta-singleton-utility/1.0.0/js/sparta-singleton-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.3/js/sparta-style-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
/* global _ cX spartaEventsUtility spartaGlobalFunctions spartaMediaQueryUtility spartaStoreUtility */

/**
 * @module
 * @name sparta-ui-layers-utility
 * @desc export a singleton instance of spartaUILayersUtility class
 */

// initialize the focus trap
const focusTrap = focusTrapUtility({});

// default settings for ui layer class
const classDefaults = {
  debug: false,
  evtNamespace: 'spaUILayer',
  closeLayerNameSpace: 'info-layer-evt',
  initNamespace: 'sparta-ui-layers-utility',
  scrollNamespace: 'scrollfix',
  globalReady: 'SPARTA_GLOBAL_READY.spartaBootstrapUtility',
  globalReadyToken: '',
  layerClass: 'spa-ui-layer',
  layerPosition: '',
  linkClass: 'spa-ui-layer-link',
  closeClass: 'spa-ui-layer-close',
  openClass: 'spa-ui-layer-opened',
  adaLayerID: 'SpartaUILayer',
  adaCloseID: 'Close',
  modalLayerClass: 'spa-ui-modal',
  infoLayerClass: 'spa-ui-info',
  layerLinkOffset: 8, // distance between link and layer for tooltip,
  nextZIndex: 1001,
  continueLinkPostfixID: 'ContinueLink',
  backLinkPostfixID: 'BackLink',
  spartaLayoutContainer: '.spa-layout-container', // page container
};

// default settings for modal layer links
const linkDefaults = {
  type: null, // required.  [ modalLayer | infoLayer | taskLayer ]
  width: null, // optional,
  layerId: null,
  layerCloseId: null,
  layerClass: 'spa-ui-layer',
  optionalClasses: '',
  onOpen: '', // callback for when the modal is opened (string).
  onClose: '', // callback for when the modal is closed (string).
  closeButton: true, // include close button in layer
  closeTriggers: [], // pass in optional close links & buttons as string or jquery object: "closeTriggers": ["#boaSocialModal .boa-social--button"]}
  closeOnEscape: true, // whether to close the modal using Esc Key
  closeAdaText: ' ',
  closeAdaTextSpacer: ': ',
  closeAdaTextOverride: '',
  interstitialType: '',
  adaCloseFocus: false, // Overwrite default styling for focus state on close icon against dark backgrounds
  interstitialBranding: 'default',
  dynamicContent: false,
  loadingText: '',
  targetAction: '',
  modalLayer: {
    class: classDefaults.modalLayerClass,
    width: 600,
  },
  infoLayer: {
    class: classDefaults.infoLayerClass,
    layerAdjustTop: 10,
    layerAdjustLeft: 10,
    width: {
      small: {
        chars: 350,
        width: 250,
        class: `${classDefaults.infoLayerClass}-small`,
      },
      medium: {
        chars: 800,
        width: 400,
        class: `${classDefaults.infoLayerClass}-medium`,
      },
      large: {
        chars: 0,
        width: 400,
        class: `${classDefaults.infoLayerClass}-large`,
      },
      default: {
        width: 250,
        class: `${classDefaults.infoLayerClass}-large`,
      },
    },
  },
};

const EVENTS = {
  MODAL_OPENED: 'MODAL_OPENED.spartaUILayersUtility',
  MODAL_CLOSED: 'MODAL_CLOSE.spartaUILayersUtility',
  FREEZE_SCROLL: 'FREEZE_SCROLL.spartaUILayersUtility',
  UNFREEZE_SCROLL: 'UNFREEZE_SCROLL.spartaUILayersUtility',
};
// MODAL_OPENED.spartaUILayersUtility:MyModule
// options specific to the call we'll make to the constructor below
const options = {
  debug: false,
  $applicationContainer: undefined,
  $body: $('body'),
  $html: $('html'),
  $window: $(window),
  $document: $(document),
  $context: undefined,
};

/**
 * @class spartaUILayersUtility
 * @classdesc Class for global implementation of UI layers like modals, interstitials, and tooltips
 */
class SpartaUILayersUtility {
  /**
   * @method
   * @name constructor
   * @desc Initialize an instance of our global ui layers class
   */
  constructor() {
    // Disable all modals, tooltips, etc. for Prerender.
    this.isPrerender = (typeof startPrerenderCapture === 'function');
    if (this.isPrerender) {
      return;
    }

    // extend class options based on defaults and provided constructor options
    this.options = Object.assign({}, classDefaults, options);

    this.options.globalReadyToken = spartaEventsUtility.sub(`${this.options.globalReady}`, this._addListeners.bind(this));

    // get current window width so we can prevent fake resize events when mobile browser hide and show the URL bar
    this.options.windowWidth = this.options.$window.width();
  }

  /**
   * Retrieve the layers object.
   * By default it will get it from the asset loader
   * If that's not available, get it from the window.spaParams
   ***This was necessary for SPARTA WIDGETS. It couldn't find the layers, therefore failed to work
   * @returns {*}
   */
  get layers() {
    let layersObj;

    const lang = spartaStoreUtility.getData('lang').split('-')[0];

    // check to see if we are in a Sparta Widget or a Sparta Page
    const widgetContext = spartaStoreUtility.getData('applicationContext');

    // if in widget get access to global params
    if (widgetContext) {
      if (widgetContext.id) {
        layersObj = window.spaWidgetParams[widgetContext.name][widgetContext.version][widgetContext.id].global[lang].layers;
      }
      else {
        layersObj = window.spaWidgetParams[widgetContext.name][widgetContext.version].global[lang].layers;
      }
    }
    else {
      layersObj = window.spaParams.global[lang].layers;
    }

    return layersObj;
  }

  get EVENTS() {
    return EVENTS;
  }

  /**
   * @method
   * @name _addListeners
   * @desc adds relevant event listeners for global UI layers
   */
  _addListeners() {
    // set applicationContainer
    this.options.$applicationContainer = $(spartaStoreUtility.getData('applicationContainer'));

    spartaEventsUtility.unsubByToken(this.options.globalReadyToken);

    this.options.$applicationContainer.on(`click.${this.options.evtNameSpace}`, `.${this.options.linkClass}`, this._onLayerLinkClick.bind(this));

    this._addTriggerTypeClass(this.options.linkClass);

    this.options.$applicationContainer.on(`animationend.${this.options.evtNamespace} oAnimationEnd.${this.options.evtNamespace} webkitAnimationEnd.${this.options.evtNamespace}`, this._infoLayerAnimationEnd.bind(this));
  }

  /**
   * @description Adds proper class name to ui-layer trigger based on type
   * @param {string} className - class to create list from
   */
  _addTriggerTypeClass(className) {
    // if the element that triggered this was a layer trigger link
    const uiLinkList = [...document.querySelectorAll(`.${className}`)];

    uiLinkList.forEach((element) => {
      // test parent node type to see if we need to modify element class
      if (element.parentElement.nodeName === 'ABBR') {
        return false;
      }

      // get data attributes
      let targetID;
      let targetDataObj;
      let type;

      if (element && element.dataset && element.dataset.options) {
        const linkOptions = JSON.parse(element.dataset.options);

        // check data options for modal type
        // if interstitial than set type as modal
        if (linkOptions && linkOptions.interstitialType) {
          type = 'modal';
        }
        // or get from rel attribute
        else {
          targetID = element.getAttribute('rel');
        }
      }

      // if we have a target ID go find content in the DOM
      const target = targetID
        ? document.getElementById(targetID)
        : undefined;

      // If content DOM found, get the type.
      if (target && target.dataset && target.dataset.options) {
        targetDataObj = JSON.parse(target.dataset.options);
        if (targetDataObj && targetDataObj.type) {
          ({ type } = targetDataObj);
        }
      }

      // finally, apply the proper class name to trigger
      if (type === 'modal') {
        element.classList.add('spa-ui-layer-modal-link');
      } else if (type === 'info') {
        element.classList.add('spa-ui-layer-tooltip-link');
      }
    });
  }

  /**
   * @param {string} url URL to load into the window
   * @param {string} windowName Name applied to popup
   * @param {string} args pop-up window arguments
   * @return {boolean} returns false always
   */
  displayPopup(url, windowName, args = 'width=750,height=450,resizable,scrollbars') {
    if (this.isPrerender) {
      return;
    }

    const defaultArgs = $.extend({}, args);
    const newWindow = window.open(url, windowName, args);
    newWindow.focus();

    return false;
  }

  /**
   * @param {nodelist} elements - list of elements to get helped
   */
  addPopupWindowHelper(elements) {
    if (this.isPrerender) {
      return;
    }

    const popupElements = Array.prototype.slice.call(elements, 0);

    popupElements.forEach((elem) => {
      if (elem.getAttribute('data-popup-event-attached')) {
        return;
      }
      elem.addEventListener('click', ((event) => {
        event.preventDefault();

        let args = '';
        const $elem = $(elem);
        const defaults = {
          block: false,
          height: 600,
          href: $elem.attr('href'),
          menubar: false,
          resizable: true,
          scrollbars: true,
          size: null,
          status: false,
          width: 400,
          windowName: 'spawin',
          x: 0,
          y: 0,
        };
        const options = Object.assign({}, defaults, ($elem.data('options') || {}));
        const sizes = {
          large: {
            height: 600,
            width: 800,
          },
          medium: {
            height: 400,
            width: 600,
          },
          small: {
            height: 200,
            width: 300,
          },
        };

        if (options.size) {
          options.width = sizes[options.size].width;
          options.height = sizes[options.size].height;
        }

        // Center window
        // TODO this doesn't center
        options.y = Math.floor((screen.availHeight - (options.height || screen.height)) / 2) - (screen.height - screen.availHeight);
        options.x = Math.floor((screen.availWidth - (options.width || screen.width)) / 2) - (screen.width - screen.availWidth);

        // If block, just open default window/tab as full window
        if (!options.block) {
          args = `${args}width=${options.width},height=${options.height},left=${options.x},top=${options.y}`;

          ['menubar', 'resizable', 'scrollbars', 'status'].forEach((toolbarFeature) => {
            if (options[toolbarFeature]) {
              args += `,${toolbarFeature}`;
            }
          });
        }

        this.displayPopup(options.href, options.windowName, args);

        elem.classList.add('force-visited');
        return false;
      }));
      elem.setAttribute('data-popup-event-attached', "1");
    });
  }

  /**
   * @method
   * @name _onLayerLinkClick
   * @desc Standard close function for modal layers
   * @param {Event} event - the click event object
   */
  _onLayerLinkClick(event) {
    const $this = $(event.currentTarget);

    this.openLayer($this, event);
  }

  /**
   * @method
   * @name _infoLayerAnimationEnd
   * @desc Listen for animation end event and remove layer if necessary
   * @param {Event} e
   */
  _infoLayerAnimationEnd(e) {
    const $target = $(e.target);

    // if our element has faded out, hide it
    if ($target.hasClass('spa-ui-animate-fadeOutUp') || $target.hasClass('spa-ui-animate-fadeOutDown')) {
      $target.hide();
    }
  }

  /**
   * @method
   * @name _setLayerOptions
   * @desc Set layer options
   * @param {Object} linkSpecificSettings = {} - settings specific links
   * @param {Object} contentOptions = {} - settings specific to this layer's content
   * @param {Object} linkOptions = {} - settings specific to this link
   */
  _setLayerOptions(linkSpecificSettings = {}, contentOptions = {}, linkOptions = {}) {
    return Object.assign({}, linkDefaults, linkSpecificSettings, contentOptions, linkOptions);
  }

  /**
   * @method
   * @name openLayer
   * @desc Open a UI layer by type all.
   * @param {(String|jQuery Collection)} layer - id of layer
   * @param {event} [e] - Event that opened layer (click, keypress), used for positioning logic
   * @example spartaUILayer.openLayer($this, event);
   */
  openLayer(obj, e, layerOptions) {
    if (this.isPrerender) {
      return;
    }

    const event = e || {};

    let $obj = obj;
    let linkOptions = {};

    let $layer;
    let $link;
    let $content;
    let contentId;
    let contentOptions;

    // prevent default action for href.
    if (event.type) {
      event.preventDefault();
    }

    // convert $obj to a jQuery collection if it isn't already
    if ($obj && !$obj.jquery) {
      $obj = $(obj);
    }

    // short circuit if no items are in our jQuery collection
    if (!$obj || !$obj.length) {
      this._debug('Error: spartaUILayer: Nothing passed in');

      return false;
    }

    // overriding application container if passed in, otherwise resettings to spartaStore value
    this.options.$applicationContainer = event.$applicationContainer || $(spartaStoreUtility.getData('applicationContainer'));

    // if the element that triggered this was a layer trigger link
    if ($obj.hasClass(this.options.linkClass)) {
      $link = $obj;

      linkOptions = $link.data('options') || {};
      contentId = $link.attr('rel');

      // if layer is an interstitial or another layer
      if (linkOptions.interstitialType) {
        linkOptions.type = 'modal';
        contentId = linkOptions.rel || `${linkOptions.interstitialType}-${linkOptions.interstitialBranding || 'default'}`;
      }

      $content = $(`#${contentId}`) || null;
    } else {
      $content = $obj;
      $link = this.options.$applicationContainer;
      contentId = $content.attr('id');
    }

    contentOptions = $content.data('options') || {};

    // options for this link and layer based on current item
    const linkSpecificSettings = {
      closeADALabel: spartaGlobalFunctions.getGlobalParams('closeADALabel') || 'x: ',
      closeText: spartaGlobalFunctions.getGlobalParams('closeText') || 'close',
      $content,
      contentId,
      endContentMsg: 'End of content',
      returnFocusToLink: event.currentTarget ? $(event.currentTarget) : this.options.$applicationContainer,
      position: {
        browserWidth: this.options.$body.width(),
        applicationWidth: this.options.$applicationContainer.width(),
        activeMouseTop: event.pageY,
        activeMouseLeft: event.pageX,
        linkWidth: $link.width(),
        linkHeight: $link.height(),
        linkOffsetTop: $link.offset().top,
        linkOffsetLeft: $link.offset().left,
        screenTop: this.options.$document.scrollTop(),
      },
    };


    /**
     * extend the options for this layer
     * order of importance: link data-options, layer data-options, link-specific content options, linkDefaults.
     */
    let o = this._setLayerOptions(linkSpecificSettings, contentOptions, linkOptions);

    // If we're JS calls openLayer function override JCR/Default strings
    o = Object.assign({}, o, layerOptions);

    // if we don't have content from a link (opened onload?), find content from options passed in
    if (typeof o.$content === 'undefined') {
      o.$content = $(`#${o.contentId}`);

      // can't find target content
      if (typeof o.$content === 'undefined' && typeof o.interstitialType === 'undefined') {
        this._debug(`cannot find: ${o.contentId}`);

        return false;
      }
    }

    // update unique IDs for ADA
    o.layerId = `${o.contentId}${this.options.adaLayerID}`;
    o.layerCloseId = `${o.layerId}${this.options.adaCloseID}`;

    // react appropriately depending on layer type
    switch (o.type) {
      case 'modal':
        $layer = this._openModalLayer(o, $layer, $link);

        this.options.$applicationContainer.addClass('spa-ui-modal-open');

        break;
      case 'info':
        $layer = this._openInfoLayer(o, $layer, $link);

        this.options.$applicationContainer.addClass('spa-ui-tooltip-open');

        break;
      default:
        return false;
    }

    // if JCR sets modal position, add it to spa-dialog class list
    if (o.layerPosition && $layer.length) {
      $layer[0].firstElementChild.classList.add('spa-ui-position-' + o.layerPosition);
    }

    // code to handle resizing
    const $modalElement = $layer.find('.spa-content');
    const $contentDiv = $modalElement.find('.content');
    const contentDiv = $contentDiv[0];
    const originalWindowWidth = this.options.$window.width();
    const resizeContentBody = function (event) {
      if (!contentDiv) {
        return false;
      }

      let contentBodyChanged = false;

      // get and store off original max height
      let origMaxHeight = contentDiv.style.maxHeight
        ? parseInt(contentDiv.style.maxHeight, 10)
        : parseInt(contentDiv.getAttribute('data-orig-max-height'), 10);

      if (!origMaxHeight && o.type === 'modal') {
        origMaxHeight = parseInt(window.getComputedStyle(contentDiv).maxHeight, 10);
        contentDiv.setAttribute('data-orig-max-height', origMaxHeight);
      }

      // reset minHeight
      if (o.type === 'info') {
        contentDiv.style.minHeight = '';
      }

      // if the height of the scrollable area is greater than the viewable height, reduce content windows max height
      if ($modalElement[0].scrollHeight > Math.max(document.documentElement.clientHeight, window.innerHeight || 0)) {
        const amountToReduce = $modalElement[0].scrollHeight - Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        contentDiv.style.maxHeight = `${contentDiv.offsetHeight - amountToReduce - 25}px`;
        if (o.type === 'info') {
          contentDiv.style.minHeight = '225px';
        }
      } else {
        // need to increase window, don't allow it to go over original max height
        const amountToIncrease = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - $modalElement[0].scrollHeight;
        if (contentDiv.offsetHeight + amountToIncrease > origMaxHeight) {
          contentDiv.style.maxHeight = `${origMaxHeight}px`;
        } else if (amountToIncrease > 0) {
          // limit tooltip maxHeight based on helix spec
          if (o.type === 'info') {
            contentDiv.style.maxHeight = '225px';
          } else {
            contentDiv.style.maxHeight = `${(contentDiv.offsetHeight + amountToIncrease) - 25}px`;
          }
        }
        contentBodyChanged = true;
      }

      // if content changed, trigger a scroll event for updating layout
      if (contentBodyChanged) {
        $contentDiv.trigger('scroll.uilayer_content');
      }
    };

    // only resize elements with class of 'content' - used primarily by interstitials
    if (contentDiv) {
      resizeContentBody.call(this);

      this.options.$window.on('resize.closeModal orientationchange.closeModal', resizeContentBody.bind(this));
    }

    $layer.data('type', o.type);

    if (o.returnFocusToLink && o.returnFocusToLink[0] && o.returnFocusToLink[0].id) {
      $layer.data('returnFocusToLink', `#${o.returnFocusToLink[0].id}`);
    } else {
      $layer.data('returnFocusToLink', 'body');
    }

    $layer.data('contentId', o.contentId);

    // common event handlers and actions
    const $closeButton = $layer.find(`.${this.options.closeClass}`);

    // function for closing layer
    const _closeLayer = function () {
      this.closeLayer($layer);

      // stop listing for ESC
      this.options.$body.off(`keydown.${this.options.evtNamespace}`);
    };

    $closeButton.off(`click.${this.options.evtNamespace}`).on(`click.${this.options.evtNamespace}`, _closeLayer.bind(this));

    // if ESC can dismiss this layer
    if (o.closeOnEscape && o.closeButton === true) {
      const _closeLayerOnEscape = function (event) {
        if (event.keyCode === 27) {
          this.closeLayer($layer);

          // stop listening for ESC
          this.options.$body.off(`keydown.${this.options.evtNamespace}`);
        }
      };

      this.options.$body.on(`keydown.${this.options.evtNamespace}`, _closeLayerOnEscape.bind(this));
    }

    // add optional close links, buttons (pass in as jquery object);
    if (o.closeTriggers && o.closeTriggers.length > 0) {
      $(o.closeTriggers).each((i, e) => {
        const $link = $layer.find(e);

        const _closeLayerWithTriggers = function () {
          this.closeLayer($layer);
        };

        $link.click(_closeLayerWithTriggers.bind(this));
      });
    }

    if ((o.onOpen && o.onOpen.length > 0) && (o.onClose && o.onClose.length > 0)) {
      this._deprecated('onOpen/onClose method is no longer supported - please use spartaEventUtilitys and spartaEventUtility.MODAL_OPENED/MODAL_CLOSED');
    }

    // allow another component to add custom content
    const addContent = function (content) {
      $layer.find('.site-specific-placeholder-content').html(content);
      resizeContentBody.call(this);
    };

    // allow another component to add custom content
    const replaceContent = function (content) {
      // since $layer is a jQuery element we'll set it as vanilla would expected
      const layer = $layer instanceof jQuery && $layer.length >= 1 ? $layer[0] : $layer;
      if (!layer) return false;

      // break content into chunks
      let target = layer.querySelector(`#${contentId}`, `.${contentId}`);
      let loading = layer.querySelector('.spa-loading');
      let buttonGroup = target.querySelector('.spa-btn-group');
      let title = target.querySelector(`#${o.contentId}_title`);
      let addContent = target.querySelector('.site-specific-placeholder-content');
      let closeButton = layer.querySelector(`#${contentId}SpartaUILayerClose`);

      // remove focus on page and reset on close button
      document.activeElement.blur();
      //closeButton.focus();

      // update content html
      let html = document.createElement("div");
      html.classList.add('content');

      // add modal title
      if (title) html.appendChild(title);

      // if content is just a string we can't appendChild
      if (typeof content === 'string') {
        html.insertAdjacentHTML('beforeend', content); // append doesn't work with strings so we convert
      }
      // else it's a DOM object which we can appendChild
      else {
        html.appendChild(content);
      };

      // add previous content and any CTA groups
      if (addContent) html.appendChild(addContent);
      if (buttonGroup) html.appendChild(buttonGroup);

      // if there is a loading element hide it
      if (loading) loading.remove();

      // remove previous content
      target.querySelector('.content').remove();

      // update layer content
      target.appendChild(html);
      target.style.display = 'block'; // show content if it was hidden by another function
    };

    const addLoader = function(text) {
      // since $layer is a jQuery element we'll set it as vanilla would expected
      const layer = $layer instanceof jQuery && $layer.length >= 1 ? $layer[0] : $layer;
      if (!layer) return false;

      // hide content
      let content = layer.querySelector(`#${contentId} .content`, `.${contentId} .content`);
      content.style.display = 'none';

      // add loader
      const loadingText = text || o.loadingText;
      let spaBody = layer.querySelector('.spa-body');
      let loading = document.createElement("div");
      loading.innerHTML= loadingText;
      loading.classList.add('spa-loading');
      spaBody.appendChild(loading);
    };

    // handle return link
    o.returnFocusToLink.addClass(this.options.openClass);

    // dispatch modal opened
    spartaEventsUtility.pub(EVENTS.MODAL_OPENED, {
      type: o.type,
      contentId: o.contentId,
      layer: $layer,
      addLoader,
      addContent,
      replaceContent
    });

    $layer.attr('aria-hidden', false);

    // ADA: always focus on close layer
    // delay required so DOM structure can update and signal JAWs to read it
    if (o.dynamicContent === false) {
      setTimeout(() => {
        if (o.closeButton === false) {
          $layer.find('.spa-header > div').trigger('focus');
        }
        else {
          $closeButton.trigger('focus');
        }
      }, 75);
    };

  }

  /**
   * @method
   * @name closeLayer
   * @desc Close a UI layer by id, type all.  Close will hide the layer and call any onClose handlers & handle return focus.
   * @param {(String|jQuery Collection)} [layer] - The layer(s) you want to close
   * @example spartaUILayer.closeLayer() //close all open layers
   * @example spartaUILayer.closeLayer('modal1'); //close layer with ID: modal1
   * @example spartaUILayer.closeLayer($('#modal1'));  //close layer with ID: modal1
   * @example spartaUILayer.closeLayer($('.spa-ui-task, .spa-ui-info'));//closes any open info & task layers
   */
  closeLayer(layer) {
    if (this.isPrerender) {
      return;
    }

    // layers will be passed in a blank (select all layers), as a string (select ID), or as jQ selector
    const $layer = (typeof layer === 'undefined') ? $(`.${this.options.layerClass}`) : ((typeof layer === 'string') ? this.options.$applicationContainer.find(`#${layer}`).slice(0, 1) : $(layer));
    focusTrap.removeTrap();
    // no layers were found
    if ($layer.length === 0) {
      return;
    }

    const _onEachItem = function (origLayer, index, element) {
      const $this = $(element);

      const o = $this.data() || {};

      const layerType = '';
      let $returnFocusToLink = o.returnFocusToLink;
      const isCurrentlyShowing = ($this.css('display') !== 'none');

      // only close layers that aren't showing
      if (!isCurrentlyShowing) return;

      // only 1 layer, handle return link
      if ($layer.length === 1) {
        // if our returnFocusToLink value isn't a jQuery collection, convert it to one
        if (!($returnFocusToLink instanceof $)) {
          $returnFocusToLink = this.options.$applicationContainer.find($returnFocusToLink).slice(0, 1);
        }

        if ($returnFocusToLink.length && $returnFocusToLink.is(':visible')) {
          $returnFocusToLink
            .removeClass(this.options.openClass)
            .focus();
        } else {
          this.options.$applicationContainer.focus();
        }
      }

      // call standard layer type onclose call back
      if ($this.hasClass(this.options.modalLayerClass)) {
        this._closeModalLayer($this);
      } else if ($this.hasClass(this.options.infoLayerClass)) {
        this._closeInfoLayer($this);
      }

      $this.attr('aria-hidden', true);

      // call on close callback;
      // check to see if function is defined as module.function, then split
      spartaEventsUtility.pub(EVENTS.MODAL_CLOSED, {
        eventType: EVENTS.MODAL_CLOSED,
        type: o.type,
        contentId: o.contentId,
        layer: $layer,
      });

      $this.data('returnFocusToLink', null);

      // if closing modal
      if ($this.hasClass(this.options.modalLayerClass)) {
        this._bodyUnfreezeScroll($this);
        this.options.$applicationContainer.removeClass('spa-ui-modal-open');
      }
      // if closing tooltip
      else if ($this.hasClass(this.options.infoLayerClass)) {
        this.options.$applicationContainer.removeClass('spa-ui-tooltip-open');
      }
    };

    // here we should have jQ selector of all layers to close
    $layer.each(_onEachItem.bind(this, layer));

    this.options.$body.off(`click.${this.options.closeLayerNameSpace}`);
  }

  /**
  * @function _keepPageFromScrolling
  * @desc  when body is set to position: fixed, this will keep the same content in the viewport
  * @desc  previous to this addition, the page would scroll to the top
  * @returns {undefined} no explicit return
  */
  _keepPageFromScrolling() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.options.$body.css('top', -scrollTop);
  }

  /**
   * @method
   * @name _bodyFreezeScroll
   * @desc Prevent scrolling of body when layer is open
   * @param {jQuery Collection} $layer - the layer that is opening
   */
  _bodyFreezeScroll($layer) {
    if ($layer.length) {
      // keep track of where the scroll was left off
      if (!this.options.$body.hasClass('spa-ui-no-js-scroll')) {
        this._keepPageFromScrolling();
      }

      this.options.$body.addClass('spa-ui-freeze-scroll');
      spartaEventsUtility.pub(EVENTS.FREEZE_SCROLL);
    }
  }

  /**
  * @function _returnScrollLocation
  * @desc  when body position: fixed is reverted, scrolls user back to the previous location
  * @returns {undefined} no explicit return
  */
  _returnScrollLocation() {
    const computedStyles = window.getComputedStyle(document.body, null);
    const topValue = computedStyles.getPropertyValue('top');
    const topValueToInteger = Math.abs(parseInt(topValue, 10));
    window.scrollTo(0, topValueToInteger);
    this.options.$body.css('top', '');
  }

  /**
   * @method
   * @name _bodyUnfreezeScroll
   * @desc Allow scrolling of body when layer is closed
   * @param {jQuery collection} $layer - the layer that is closing
   */
  _bodyUnfreezeScroll($layer) {
    if ($layer.length && this.options.$body.hasClass('spa-ui-freeze-scroll')) {
      // remove our scroll-stopping class from the body
      this.options.$body.removeClass('spa-ui-freeze-scroll');

      // put the user back at their original scroll position
      if (!this.options.$body.hasClass('spa-ui-no-js-scroll')) {
        this._returnScrollLocation();
      }

      spartaEventsUtility.pub(EVENTS.UNFREEZE_SCROLL);
    }
  }

  /**
   * @method
   * @name _closeModalLayer
   * @desc standard close function for modal layers
   */
  _closeModalLayer($layer) {
    $layer.css('display', 'none');

    const $spaContent = $layer.find('.content');
    $spaContent[0].scrollTop = 0;
    const $alphaLayer = $spaContent.find('.spa-content-alpha-layer');

    if ($alphaLayer) {
      $spaContent.off('scroll.uilayer_content');
    }

    this.updatePageContainerADA(false);
  }

  /**
   * @method
   * @name _closeInfoLayer
   * @desc standard close function for info layers
   * @param {jQuery Collection} $layer - InfoLayer we are closing
   */
  _closeInfoLayer($layer) {
    if ($layer.hasClass('spa-ui-animate-fadeInDown')) {
      $layer
        .removeClass('spa-ui-animate-fadeInDown')
        .addClass('spa-ui-animate-fadeOutUp');
    } else if ($layer.hasClass('spa-ui-animate-fadeInUp')) {
      $layer
        .removeClass('spa-ui-animate-fadeInUp')
        .addClass('spa-ui-animate-fadeOutDown');
    }

    const $spaContent = $layer.find('.content');
    $spaContent[0].scrollTop = 0;
    const $alphaLayer = $spaContent.find('.spa-content-alpha-layer');

    if ($alphaLayer) {
      $spaContent.off('scroll.uilayer_content');
    }
  }

  /**
   * @method
   * @name _getNextZindex
   * @desc Set the next Z Index for UI layer
   * @param {Object} o - link configuration Object
   * @return zIndex;
   */
  _getNextZindex(o) {
    return this.options.nextZIndex++;
  }

  /**
   * @method
   * @name _formatCloseLink
   * @desc
   *  Format close link for all layers per ADA requirements
   *  Add ada-hidden text to the close link to make sure they are unique & meaning ful per ADA using these rules :
   *      Close <span class="ada-hidden"> Layer: {title or dynamic content as determined by rules} </span>.
   *          Rules to generate a unique close link:
   *              1. Pass in closeAdaTextOverride
   *              2. Content from: <h3>, <h2> <h4> <.ada-title>
   *              3. returnFocusToLink text
   *              4. Content from: 1st 50 characters of content from the 1st <p>
   *              5. Default text "close layer"
   * @param {Object} o - link configuration object
   */
  _formatCloseLink(o) {
    const _updateAdaCloseLink = function (layerHeaderText) {
      o.closeAdaText += (o.type === "modal") ?
                        (o.closeAdaText != undefined ? o.closeAdaText : (spartaGlobalFunctions.getGlobalParams("closeModalADAText") || "modal")) :
                        (spartaGlobalFunctions.getGlobalParams("closeLayerADAText") || "layer") ;
      if (layerHeaderText) {
          o.closeAdaText += `${o.closeAdaTextSpacer} ${layerHeaderText}`;
      }
    };

    if (o.closeAdaTextOverride) {
      _updateAdaCloseLink(o.closeAdaTextOverride);
    } else if (o.$content.find('h3').length > 0) {
      _updateAdaCloseLink(o.$content.find('h3:first').text());
    } else if (o.$content.find('h2').length > 0) {
      _updateAdaCloseLink(o.$content.find('h2:first').text());
    } else if (o.$content.find('h4').length > 0) {
      _updateAdaCloseLink(o.$content.find('h4:first').text());
    } else if (o.$content.find('.ada-title').length > 0) {
      _updateAdaCloseLink(o.$content.find('.ada-title').text());
    } else if (o.returnFocusToLink.length > 0 && o.returnFocusToLink.text().length > 0 &&
      !o.returnFocusToLink.is('[data-sparta-container]')) {
      _updateAdaCloseLink(o.returnFocusToLink.text().replace(/layer/g, ''));
    } else if (o.$content.find('p').length > 0) {
      _updateAdaCloseLink(o.$content.find('p:first').text().substr(0, 50));
    } else {
      _updateAdaCloseLink();
    }
  }

  /**
   * @method
   * @name _getLayerPos
   * @desc
   *  Returns the horizontal center point of the link that triggered this layer and a relative x and y value
   *  x can be -1, 0, or 1:
   *      * -1 means the layer should align to the left of the link
   *      * 0 means the layer should center on the link
   *      * 1 means the layer should align to the right of the link
   *  y can be -1 or 1:
   *      * -1 means the layer should open above the link
   *      * 1 menas the layer should open below the link
   * @param {jQuery collection} $layer (the layer that is opening)
   * @param {jQuery collection} $link (this link that triggered this layer)
   * @return { x, y, center }
   */
  _getLayerPos($layer, $link) {
    // getBoundingClientRect will give us the width, height, top and left of the link relative to the viewport
    const link = $link[0].getBoundingClientRect();
    const layerBounding = $layer[0].getBoundingClientRect();
    const docHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    // get viewport width and height, we'll need this to decide where to position the layer
    const viewport = {
      width: this.options.$window.width(),
      height: this.options.$window.height(),
    };

    // get layer width and height, we'll need this to decide where to position the layer
    const layer = {
      width: $layer.width(),
      height: $layer.height(),
    };

    const center = this._getLinkCenter(link);

    // is layer height is taller than screen force tooltip to be displayed above link
    const layerHeightToScreenCheck = (Math.max(layerBounding.top, 0) + layerBounding.height) >= docHeight;

    // return our positioning data
    return {
      x: this._getLayerX(link, layer, viewport),
      y: this._getLayerY(link, layer, viewport),
      center,
      layerHeightToScreenCheck,
    };
  }

  /**
   * @method
   * @name _getLinkCenter
   * @desc Return the center point of the link relative to the viewport
   * @param {Object} link - getBoundingClientRect for link element
   * @return Number
   */
  _getLinkCenter(link) {
    return link.left + (link.width / 2);
  }

  /**
   * @method
   * @name _getLayerY
   * @desc
   *  Figure out whether the layer should appear below or above the link
   *      -1 = above the link
   *      1 = below the link
   * @param {Object} link - getBoundingClientRect for link element
   * @param {Object} layer - layer width and height
   * @param {Object} viewport - viewport width and height
   * @return Number
   */
  _getLayerY(link, layer, viewport) {
    // return 1 or -1 to signify which direction the layer should fade in from
    return (link.top >= layer.height) ? -1 : 1;
  }

  /**
   * @method
   * @name _getLayerX
   * @desc
   *  Figure out whether the layer should appear below or above the link
   *      -1 = align to left edge of link
   *      0 = center horizontally on link
   *      1 = align to right edge of link
   *      2 = center horizontally on the page below the link
   *      3 = layer content too large, open a modal window
   * @param {Number} link - getBoundingClientRect for link element
   * @param {Object} layer - layer width and height
   * @param {Object} viewport - viewport width and height
   * @return Number
   */
  _getLayerX(link, layer, viewport) {
    const center = this._getLinkCenter(link);

    // by default we'll return 0 and center the layer horizontally on the link
    let x = 0;

    if (layer.width >= viewport.width) {
      // if the layer width is greater then the viewport width, show a modal window
      x = 3;
    } else if ((layer.width >= link.right) && (layer.width >= viewport.width - link.left)) {
      // if the layer width is greater then the space available on either side, center the layer on the screen.
      x = 2;
    } else if (viewport.width - link.left >= layer.width) {
      // if the viewport width minus the left edge of the link is greater than the layer width, align to the left edge of the link
      x = -1;
    } else if (link.right - layer.width >= 0) {
      // if the right edge of the link minus the layer width is greater than zero, align to the right edge of the link
      x = 1;
    }

    return x;
  }

  /**
   * @method
   * @name _openModalLayer
   * @desc open modal layers
   * @param {Object} o - configuration object
   * @param {jQuery Collection} $layer - layer element
   * @param {jQuery Collection} $link - link element
   * @return jQuery Collection
   */
  _openModalLayer(o, $layer, $link) {
    // close any open layers
    this.closeLayer();

    // calculated values start with _
    // get desired, or default to type default
    const _widthValue = o.width || o.modalLayer.width;

    $layer = this.options.$applicationContainer.find(`#${o.layerId}`).slice(0, 1);

    // layer has been opened before
    if ($layer.length > 0) {
      // Update interstitial continue link
      if (o.interstitialType) {
        $layer.find('.spa-body').html(this._generateInterstitialContentHTML(o, $link));
      }

      $layer.removeClass('full-width');
      $layer.css('display', 'block');
    } else {
      // close link
      this._formatCloseLink(o);

      // generate modal layer wrapper
      const modalLayerElement = document.createElement('div');
      modalLayerElement.id = o.layerId;
      modalLayerElement.style.zIndex = this._getNextZindex(o);

      const htmlOptions = {
        widthValue:  _widthValue === 'auto' ? _widthValue : `${_widthValue}px`,
      };

      let spaBody = '';

      const lang = (spartaStoreUtility.getData('lang') === 'en-us' ? 'en' : 'es');
      const branding = o.interstitialType && o.interstitialType.length > 0 ? o.interstitialBranding : o.branding;

      if (branding) {
        htmlOptions.customHeaderStyles = {
          'background-image': `url('${this.layers.modalHeaderBackgrounds[branding]}')`,
        };
        o.optionalClasses += `${(o.optionalClasses && o.optionalClasses.length > 0 ? ' ' : '')}spa-ui-modal-interstitial`;
        o.interstitialBranding = branding;
      }

      // generate and format layer markup
      if (o.interstitialType) {
        spaBody = this._generateInterstitialContentHTML(o, $link, modalLayerElement);
      } else {
        this._addClassesToElement(modalLayerElement, [o.layerClass, o.modalLayer.class].concat(o.optionalClasses.split(' ')));
        spaBody = (o.$content instanceof $ ? o.$content.detach().removeClass('hide') : o.$content);
      }

      // create and add HTML to body
      const modalLayerHTML = this._generateModalHTML(o, htmlOptions);
      modalLayerElement.innerHTML = modalLayerHTML;
      this.options.$applicationContainer.append(modalLayerElement);

      const newModal = this.options.$applicationContainer.find(`#${modalLayerElement.id}`);
      if (spaBody instanceof $) {
        spaBody.appendTo(newModal.find('.spa-body'));
      } else {
        newModal.find('.spa-body').append(spaBody);
      }
    }

    // Update links for Coremetrics
    this._updateLinksDataCollection();

    $layer = this.options.$applicationContainer.find(`#${o.layerId}`).slice(0, 1);

    // freeze body scroll, add alpha layer to bottom of scrollable area
    this._bodyFreezeScroll($layer);
    this._addAlphaLayer($layer.find('.spa-body'));

    // layer is open, redo positioning logic
    const $modalDialog = $layer.find('.spa-dialog');
    const _layerWidth = $modalDialog.width();

    // add positioning class to modal from scripting instead of JCR
    $modalDialog.addClass(classDefaults.layerPosition);

    // RWD: if brower width > layer -> center
    if (o.position.browserWidth <= _layerWidth) {
      $modalDialog.addClass('full-width');
    }

    // closing interstitial
    const closeModal = function (event) {
      this.options.$window.off('resize.closeModal orientationchange.closeModal');
      this.closeLayer(o.layerId);
    };

    this.options.$applicationContainer.find('.close-interstitial.spa-btn').off('click').on('click', closeModal.bind(this));

    // ADA: Keep tabbing inside of modal
    focusTrap.setContainer($modalDialog[0]).attachTrap();
    this.updatePageContainerADA(true);

    return $layer;
  }

  /**
   * @method
   * @name _generateModalHTML
   * @desc generate the HTML required for Modals
   * @param {Object} o - configuration object
   * @param {Object} htmlOptions - {customHeaderStyles:{"key":"value"}}
   * @return templated string
   */
  _generateModalHTML(o, htmlOptions) {
    let customHeaderStyles = '';

    if (htmlOptions.customHeaderStyles) {
      _.each(htmlOptions.customHeaderStyles, (value, key) => {
        customHeaderStyles += `${key}:${value};`;
      });
    }

    const describedBy = o.describedBy ? ` aria-describedby="${o.describedBy}"` : '';
    const disabledCloseFocusSetter = o.closeButton === false ? `<div class="ada-hidden" tabindex="-1">${o.closeText}${o.closeAdaText}</div>` : ``;

    const modalHTML = `
             <div class="spa-dialog" role="dialog" aria-labelledby="${o.contentId}_title"${describedBy} style="z-index: ${this._getNextZindex(o)}; width: ${htmlOptions.widthValue};">
                 <div class="spa-content">
                     <div class="spa-header${(o.interstitialBranding ? ` ${o.interstitialBranding}` : '')}"${customHeaderStyles ? ` style="${customHeaderStyles}"` : ''}>
                        ${disabledCloseFocusSetter}
                        <a role="button" id="${o.layerCloseId}" class="spa-ui-layer-close svg-button${((o.interstitialType || o.adaCloseFocus) ? ' svg-button--dark-bg close-interstitial' : '')}${(!o.closeButton ? ' hide' : '')}" href="javascript:void(0);">
                             <span class="ada-hidden">${o.closeADALabel}${o.closeText}${o.closeAdaText}</span>
                             <span class="spa-close-x" aria-hidden="true">×</span>
                         </a>
                     </div>
                     <div class="spa-body"></div>
                 </div>
             </div>
         `;

    return modalHTML;
  }

  /**
   * @method
   * @name _addAlphaLayer
   * @desc adds alpha layer and scroll watcher
   * @param {jQuery Collection} $baseLayer - base layer item to watch
   * @return {false|undefined} - returns false on error, otherwise undefined
   */
  _addAlphaLayer($baseLayer) {
    const $spaBody = $baseLayer.hasClass('spa-body') ? $baseLayer : $baseLayer.find('.spa-body');
    const $alphaLayer = $baseLayer.find('.spa-content-alpha-layer');

    if ($alphaLayer.length) {
      $alphaLayer.remove();
    }

    $baseLayer.append('<div class="spa-content-alpha-layer"></div>');

    // only add alpha for scrollable content
    if ($spaBody.find('.content').length === 0) {
      return false;
    }

    // need to wait for the layout to complete
    const myInterval = setInterval(() => {
      const newHeight = $spaBody.find('.content')[0].scrollHeight;
      this._showHideAlphaOverlay($spaBody.find('.content')[0], $spaBody.find('.spa-content-alpha-layer'));

      if (newHeight && newHeight > 0) {
        clearInterval(myInterval);

        // watch for scrolling
        const $spaContent = $baseLayer.find('.content');
        const $alphaLayer = $baseLayer.find('.spa-content-alpha-layer');

        if ($alphaLayer) {
          if ($spaContent[0].scrollHeight > $spaContent[0].clientHeight + 1) {
            $alphaLayer.css('display', 'block');
          }

          $spaContent
            .on('scroll.uilayer_content', (event) => {
              this._showHideAlphaOverlay(event.currentTarget, $alphaLayer);
            });
        }
      }
    }, 10);
  }

  /**
   * @method
   * @name _showHideAlphaOverlay
   * @desc determines if alpha layer should be visible or not, based on scroll position
   * @param {Element} currentTarget - item that's fired the scroll event (the .content section)
   * @param {jQuery Collection} $alphaLayer - The alpha layer element to reposition or show/hide
   * @return {undefined}
   */
  _showHideAlphaOverlay(currentTarget, $alphaLayer) {
    let displayValue = 'none';

    // need to use this instead of .height() as JQuery adds elements and throws off measurement
    const alphaLayerHeight = 40;

    // only include things that would have room for the alpha's height
    if (currentTarget.scrollHeight > alphaLayerHeight) {
      // if not at the bottom of the scrollable area, modify CSS
      if (currentTarget.scrollTop + currentTarget.clientHeight + 1 < currentTarget.scrollHeight) {
        displayValue = 'block';
      }
    }

    $alphaLayer.css('display', displayValue);
  }

  /**
   * @method
   * @name _openInfoLayer
   * @desc open info layers
   * @param {Object} o - configuration object
   * @param {jQuery Collection} $layer - layer element
   * @param {jQuery Collection} $link - link element
   * @return jQuery Collection
   */
  _openInfoLayer(o, $layer, $link) {
    // layer doesn't exist yet
    let _widthValue;
    let _sizeClass;
    let _zIndex;
    let withinModal = false;
    const linkOptions = $link.data('options') || {};
    const tooltipMaxHeight = linkOptions.maxHeight || null
    // allow access to global object within functions
    let _self = this;

    // close any open layers
    if (this.options.$applicationContainer.find(`.${classDefaults.modalLayerClass}`).find($link).length === 0) {
      this.closeLayer();
    }
    // if tooltip is within active modal, don't close said modal
    else {
      withinModal = true;
    }

    $layer = this.options.$applicationContainer.find(`#${o.layerId}`);

    if (!$layer.find('.spa-layer-content').length) {
      // dynamically set width based on amount of content
      const _contentLength = o.$content.find(' > :not(".ada-hidden")').text().replace(/ {2}/g, '').length;

      if (_contentLength < o.infoLayer.width.small.chars) {
        _widthValue = o.infoLayer.width.small.width;
        _sizeClass = o.infoLayer.width.small.class;
      } else if (_contentLength < o.infoLayer.width.medium.chars) {
        _widthValue = o.infoLayer.width.medium.width;
        _sizeClass = o.infoLayer.width.medium.class;
      } else {
        _widthValue = o.infoLayer.width.large.width;
        _sizeClass = o.infoLayer.width.large.class;
      }

      // create close link
      this._formatCloseLink(o);

      // generate Info Layer Wrapper
      const infoLayerElement = document.createElement('div');

      _zIndex = this._getNextZindex(o);

      infoLayerElement.id = o.layerId;
      //infoLayerElement.style.zIndex = _zIndex;
      this._addClassesToElement(infoLayerElement, [o.layerClass, o.infoLayer.class, _sizeClass]);

      const infoLayerHTML = `
                 <div class="spa-layer-content" role="dialog" aria-labelledby="${o.contentId}_title">
                     <div class="spa-content">
                         <div class="spa-header">
                             <a role="button" id="${o.layerCloseId}" class="spa-ui-layer-close svg-button" href="javascript:void(0);">
                                 <span class="ada-hidden">${o.closeText}${o.closeAdaText}</span>
                                 <span class="spa-close-x" aria-hidden="true">×</span>
                             </a>
                         </div>
                         <div class="spa-body"></div>
                         <div tabindex="0" class="ada-hidden ada-visible-focus">${o.endContentMsg}</div>
                     </div>
                 </div>
             `;

      const layerContent = o.$content.removeClass('hide').detach();
      if (tooltipMaxHeight) {
        layerContent.find('.content').css('max-height', tooltipMaxHeight);
      } else {
        // a max-height is required for super tall tooltips to prevent incorrect placements on open
        layerContent.find('.content').css('max-height', '225px'); // 225 matches helix spec
      }

      infoLayerElement.innerHTML = infoLayerHTML;
      $link.after(infoLayerElement);

      $layer = this.options.$applicationContainer.find(`#${o.layerId}`);

      $layer
        .data('linkElement', $link[0].id)
        .find('.spa-body')
        .append(layerContent);
    } else if ($layer.hasClass('spa-ui-animate-fadeOutUp') || $layer.hasClass('spa-ui-animate-fadeOutDown')) {
      $layer.show();
      $link.after($layer); // moves tooltip after trigger in DOM
    }

    // remove fadeout animation classes
    $layer.removeClass('spa-ui-info-modal spa-ui-animate-fadeOutUp spa-ui-animate-fadeOutDown');

    // place tooltip in viewport
    _self._tooltipPositioning(_self, o, $layer, $link, withinModal);

    // update tooltip position on resize or scroll
    this.options.$window.on('scroll resize', function() {
      _self._tooltipPositioning(_self, o, $layer, $link, withinModal);
    });

    // close tooltip within modal content scroll since it can't calculate proper position
    /*
    if (withinModal === true) {
      let modalContent = this.options.$applicationContainer.find(`.${classDefaults.modalLayerClass} .spa-content .content`).eq(0);
      modalContent.on('scroll resize', function() {
        _self.closeLayer($layer);
      });
    }
    */

    return $layer;
  }

  /**
   * @method
   * @name _addClassesToElement
   * @desc helper method to add array of classes to an element
   * @param {Element} element - HTML element to add the classes to
   * @param {array} classes - list of classes to add to element, if they're valid
   * @return {undefined}
   */
  _addClassesToElement(element, classes) {
    classes.forEach((val) => {
      if (val && val.length > 0) {
        element.classList.add(val);
      }
    });
  }

  _getElementPosition(element, position) {
    const bodyRect = document.body.getBoundingClientRect();
    const elemRect = element[0].getBoundingClientRect();
    const appRect = this.options.$applicationContainer[0].getBoundingClientRect();

    if (position === 'top') {
      return elemRect.top - appRect.top;
    }
    return elemRect.left - appRect.left;
  }

  /**
   * @method
   * @name _generateInterstitialContentHTML
   * @desc generates the interstitial content body HTML
   * @param {Object} o - configuration object
   * @param {jQuery Collection} $link - link element
   * @param {Element} modalLayerElement - optional modal layer to set
   *                                      interstitial specific classes to.
   * @return {string}
   */
  _generateInterstitialContentHTML(o, $link, modalLayerElement = null) {
    /**
     * AVAILABLE OPTIONS
     * interstitialType: "language-change" | "leaving-site" | "leaving-and-language"
     * interstitialBranding: "default" | "edge" | "enterprise" | "co-brand"
     * targetAction: "new-tab"
     */
    if (o.interstitialType !== 'leaving-site' && o.interstitialType !== 'language-change' && o.interstitialType !== 'leaving-and-language') {
      this._debug('Use one of the standard interstitialType values: language-change, leaving-site, leaving-and-language');
    }

    if (o.interstitialBranding !== 'default' && o.interstitialBranding !== 'edge' && o.interstitialBranding !== 'enterprise' && o.interstitialBranding !== 'co-brand') {
      this._debug('Use one of the standard interstitialBranding values: edge, enterprise, co-brand OR leave this property out of your config completely for a default value of "default"');
    }

    const lang = (spartaStoreUtility.getData('lang') === 'en-us' ? 'en' : 'es');
    const interstitialContent = this.layers[o.interstitialType] || {};
    const interstitialGoBackText = interstitialContent.btnText2[o.interstitialBranding] || {};
    const continueLink = $link.attr('href');
    const anchorID = $link.attr('id');

    const classesToAdd = ['spa-ui-modal-interstitial', o.layerClass, o.modalLayer.class];

    if (o.optionalClasses) {
      classesToAdd.concat(o.optionalClasses.split(' '));
    }

    if (modalLayerElement) {
      this._addClassesToElement(modalLayerElement, classesToAdd);
    }

    const contentWrapperId = o.rel || 'modalContentInt';

    return `
         <div id="${contentWrapperId}">
           <h1 id="${o.contentId}_title" class="spa-ui-layer-title">${interstitialContent.header}</h1>
           <div class="content">
             ${interstitialContent.body}
             <p class="site-specific-placeholder-content"></p>
             <p class="spa-btn-group">
               <a role="button" href="${continueLink}" ${(o.targetAction === 'new-tab' ? ' target="_blank"' : '')} id="${anchorID}${classDefaults.continueLinkPostfixID}" class="spa-btn spa-btn--small spa-btn--primary ${(o.targetAction === 'new-tab' ? ' close-interstitial' : '')}">
                 ${interstitialContent.btnText1}
               </a>
               <a role="button" href="javascript:void(0);" id="${anchorID}${classDefaults.backLinkPostfixID}" class="spa-btn spa-btn--small spa-btn--secondary close-interstitial">
                 ${interstitialGoBackText}
               </a>
             </p>
           </div>
         </div>`;
  }

  /**
   * @method
   * @name updatePageContainerADA
   * @desc toggles aria-hidden attribute to true or false
   * @param {boolean} isHidden - Boolean to toggle aria hidden to
   * @memberof SpartaUILayersUtility
   */
  updatePageContainerADA(isHidden) {
    if (this.isPrerender) {
      return;
    }

    const $pageContainer = this.options.$document.find(classDefaults.spartaLayoutContainer);
    if ($pageContainer.length > 0) {
      $pageContainer.attr('aria-hidden', isHidden);
    }
  }

  /**
   * @method
   * @name _updateLinksDataCollection
   * @desc Rescan DOM for coremetrics to get new links
   */
  _updateLinksDataCollection() {
    if (typeof cX === 'function') {
      cX('onload');
      this._debug('_updateLinksDataCollection(): cX scan for new links');
    }
  }

  /**
   * @method
   * @name _debug
   * @desc console.log out debug messages if debug is set to true
   * @param {Any} msg
   */
  _debug(msg) {
    if (this.options.debug) {
      if (window.console && console.log) {
        console.log('ui-layer debug: ', msg);
      }
    }
  }

  /**
   * @method
   * @name _deprecated
   * @desc console.error out debug messages if debug is set to true
   * @param {Any} msg
   */
  _deprecated(msg) {
    if (this.options.debug) {
      console.error(`ui-layer DEPRECATED: ${msg}`);
    }
  }

  /**
   * @method
   * @name _tooltipPositioning
   * @desc positions the tooltip orientation to the triggers position
   * @param {Object} o - configuration object
   * @param {jQuery Collection} $layer - layer element
   * @param {jQuery Collection} $link - link element
   * @param {Element} layerPosition - provides -1 or 1 depending on whether the layer should open below or above the link
   */
  _tooltipPositioning(_self, o, $layer, $link, tooltipWithinModal) {
    // get -1 or 1 depending on whether the layer should open below or above the link
    const layerPosition = _self._getLayerPos($layer, $link);

    // get position of link relative to viewport
    const linkViewportOffset = $link[0].getBoundingClientRect();
    const linkViewportOffsetTop = linkViewportOffset.top;
    const linkOptions = $link.data('options') || {};
    const tooltipDefaultPosition = linkOptions.position || null;

    // in the small viewport or the layer width is too large, this layer should act like a modal
    const appBoundingRect = this.options.$applicationContainer[0].getBoundingClientRect();
    let newLeft = this._getElementPosition($link);
    const layerCenter = $layer.outerWidth() / 2;
    const linkCenter = $link.outerWidth() / 2;

    // left/center/right
    if (layerPosition.x === 0) { // center
      if ($link.hasClass('icon-link')) { // differing center positions based on link type
        newLeft = (newLeft - ($layer.outerWidth() * 0.8) + linkCenter);
        $layer.addClass('tooltip-icon-position');
      } else {
        newLeft = (newLeft - ($layer.outerWidth() * 0.5) + linkCenter);
      }
    } else if (layerPosition.x === 1) { // right
      newLeft = (newLeft - $layer.outerWidth()) + $link.outerWidth();
      $layer.addClass('tooltip-right-position');
    } else if (layerPosition.x === 2) {
      newLeft = (appBoundingRect.right - layerCenter);
    } else if (layerPosition.x === -1) {
      $layer.addClass('tooltip-left-position');
      if ($link.hasClass('icon-link')) { // differing left positions based on link type
        newLeft -= (40 - linkCenter);
      }
    };

    $layer.css({
      position: '',
      top: '',
      left: `${newLeft}px`,
      right: '',
      height: '',
      'max-width': ''
    });

    if (tooltipWithinModal === true || !window.matchMedia(spartaMediaQueryUtility.mediaQueries[1].mediaQuery).matches && layerPosition.x !== 3) {
      $layer.css({
        'max-width': `calc(100% - 20px)`
      });
    }

    // top or bottom
    if ((layerPosition.y === -1 && tooltipDefaultPosition !== 'bottom') || layerPosition.layerBoundingLayersBottom === true) { // above the link
      let newTop = (linkViewportOffsetTop - $layer.outerHeight()) - this.options.layerLinkOffset;
      if ($link.hasClass('icon-link')) {
        newTop += (this.options.layerIconOffset - 6);
      }
      $layer
        .css('top', `${newTop}px`)
        .addClass('spa-ui-animate-fadeInUp').removeClass('spa-ui-animate-fadeInDown')
        .addClass('tooltip-top-position');

    } else if (layerPosition.y === 1 || tooltipDefaultPosition === 'bottom') { // below the link
      let newTop = (linkViewportOffsetTop + $link.outerHeight()) + this.options.layerLinkOffset;
      if ($link.hasClass('icon-link')) {
        newTop += this.options.layerIconOffset;
      }
      $layer
        .css('top', `${newTop}px`)
        .addClass('spa-ui-animate-fadeInDown').removeClass('spa-ui-animate-fadeInUp')
        .removeClass('tooltip-top-position');
    }

    // in the small viewport or the layer width is too large than make it fit device width instead of positioning under trigger
    if (!window.matchMedia(spartaMediaQueryUtility.mediaQueries[1].mediaQuery).matches && layerPosition.x !== 3) {
      $layer.css({
        left: tooltipWithinModal === true ? '' : '10px',
      });
    }

    if (tooltipWithinModal === true) {
      $layer.css({
        position: 'absolute',
        top: '',
        left: '',
        'margin-top': `${this.options.layerLinkOffset}px`,
      });
    }

    $layer.removeClass('spa-ui-info-modal');
  } // END _tooltipPositioning
}

// export new instance of UI Layer Utility
// export default new spartaUILayersUtility(options);
const instance = new SpartaUILayersUtility();
spartaSingletonUtility('SpartaUILayersUtility', () => instance);
export default instance;
